<template>
  <div>
    <div class="page-title">New People List Entry</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add People List Entry"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.lists-entries.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New People List Entry",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ListEntry.new({
        list_id: this.$route.params.listId,
      });
      this.form = data;
    },
    async create() {
      await this.$api.ListEntry.create(this.form);
      this.$router.push("/widgets/lists");
    },
  },
};
</script>

<style></style>
